import React from 'react'
import { useConfig } from 'customer/routes'
import styled from 'styled-components'
import { styleTheme } from '../../style/theme'

import { FairTimeShowCustomCompleteProps, FairTimeShowDefaultCompleteProps } from './FairTimeShowComplete.types'
import { DEFAULT_BRIDAL_FAIR_PAGES_THANKS_MESSAGE } from 'crm/components/features/BridalFairPages/const'

type Config = {
  thanksMessage: string | null
}

export const FairTimeShowCompletePage: React.FC = () => {
  const config = useConfig() as Config

  return config.thanksMessage ? (
    <StyledCustomCompletePage thanksMessage={config.thanksMessage} />
  ) : (
    // サンクスメッセージが設定されていない＝フェアの詳細から遷移したケース
    <StyledDefaultCompletePage />
  )
}

const CustomCompletePage: React.FC<FairTimeShowCustomCompleteProps> = ({ className, thanksMessage }) => {
  return (
    <div className={className}>
      <pre>{thanksMessage}</pre>
    </div>
  )
}

const StyledCustomCompletePage = styled(CustomCompletePage)`
  max-width: 768px;
  margin: 0 auto;
  color: ${styleTheme.colors.black};
  background-color: ${styleTheme.colors.white};
  padding: 32px 16px;
  font-size: 14px;
  line-height: 1.8;
`

const DefaultCompletePage: React.FC<FairTimeShowDefaultCompleteProps> = ({ className }) => {
  return (
    <div className={className}>
      <pre>{DEFAULT_BRIDAL_FAIR_PAGES_THANKS_MESSAGE}</pre>
    </div>
  )
}

const StyledDefaultCompletePage = styled(DefaultCompletePage)`
  max-width: 768px;
  margin: 0 auto;
  color: ${styleTheme.colors.black};
  background-color: ${styleTheme.colors.white};
  padding: 32px 16px;
  font-size: 14px;
  line-height: 1.8;
`
